var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.174,
    height: 21.571,
    viewBox: "4.794 3.595 19.174 21.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1285"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "theaters_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.571 3.595v2.397h-2.397V3.595H9.587v2.397H7.19V3.595H4.794v21.572H7.19V22.77h2.397v2.397h9.587V22.77h2.397v2.397h2.397V3.595h-2.397ZM9.587 20.373H7.19v-2.397h2.397v2.397Zm0-4.794H7.19v-2.397h2.397v2.397Zm0-4.793H7.19V8.389h2.397v2.397Zm11.984 9.587h-2.397v-2.397h2.397v2.397Zm0-4.794h-2.397v-2.397h2.397v2.397Zm0-4.793h-2.397V8.389h2.397v2.397Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 357"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "music_note_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.38 9.187v6.088a2.307 2.307 0 0 0-1.153-.317 2.308 2.308 0 1 0 2.308 2.308v-5.77h2.308V9.187h-3.462Z",
    fill: "#f7f6f0",
    fillRule: "evenodd",
    "data-name": "Tracciato 355"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.844d3c9fd31af123bb27b11df96a4f1f.svg";
export { ForwardRef as ReactComponent };